import { RotateCcw, RotateCw } from 'lucide-react'

import { Button } from '@/components/ui/button'

type SkipButtonProps = {
  seconds: number
  onClick: () => void
}

export const SkipButton = ({ seconds, onClick }: SkipButtonProps) => {
  const isBackward = seconds < 0
  const absoluteSeconds = Math.abs(seconds)
  const Icon = isBackward ? RotateCcw : RotateCw

  return (
    <Button
      onClick={onClick}
      variant="ghost"
      title={`${absoluteSeconds}秒${isBackward ? '戻る' : '進む'}`}
      className="relative w-10 h-10 p-1 [&_svg]:w-8! [&_svg]:h-8!"
    >
      <Icon size={32} />
      <span className="absolute text-xs font-bold">{absoluteSeconds}</span>
    </Button>
  )
}
